import { render, staticRenderFns } from "./teamReminder.vue?vue&type=template&id=571dd39d&scoped=true&"
import script from "./teamReminder.vue?vue&type=script&lang=js&"
export * from "./teamReminder.vue?vue&type=script&lang=js&"
import style0 from "./teamReminder.vue?vue&type=style&index=0&id=571dd39d&prod&scoped=true&lang=css&"
import style1 from "./teamReminder.vue?vue&type=style&index=1&id=571dd39d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "571dd39d",
  null
  
)

export default component.exports